import {
    TDescendant,
    TElement,
    TText,
    isElement,
    isElementList,
    isText,
} from "@udecode/plate-common";

import { Heading, Paragraph } from "./typography";

export default function RichTextContent({ content: elements }: { content: unknown }) {
    if (!isElementList(elements)) {
        console.warn("Unable to render given rich text payload:", elements);
        return null;
    }

    return elements.map((el, i) => <RichTextElement key={i} element={el} />);
}

function RichTextElement({ element }: { element: TElement }) {
    const childNode = element.children.map((descendant, i) => (
        <RichTextDescendant key={i} descendant={descendant} />
    ));

    if (element.type === "paragraph") {
        return <Paragraph>{childNode}</Paragraph>;
    }
    if (element.type === "heading") {
        return <Heading as="h2">{childNode}</Heading>;
    }

    console.warn("Unable to render element type:", element.type, "Defaulting to paragraph.");
    return <Paragraph>{childNode}</Paragraph>;
}

function RichTextDescendant({ descendant }: { descendant: TDescendant }) {
    if (isElement(descendant)) {
        return <RichTextElement element={descendant} />;
    }
    if (isText(descendant)) {
        return <RichTextLeaf leaf={descendant} />;
    }
}

function RichTextLeaf({ leaf }: { leaf: TText }) {
    if (leaf.bold) {
        return <b>{leaf.text}</b>;
    }
    if (leaf.italic) {
        return <i>{leaf.text}</i>;
    }
    return leaf.text;
}
